import axios from 'axios'
import { serverUrl } from './config'
import getAuthHeader from '../util/getAuthHeader'
import store from '../store'

export default (next) => {
  if (localStorage.getItem('id_token') !== null) {
    const userData = {
      authenticated: true,
      is_admin: localStorage.getItem('is_admin') === 'true',
      firstname: localStorage.getItem('firstname'),
      lastname: localStorage.getItem('lastname'),
      email: localStorage.getItem('email'),
      discount: localStorage.getItem('discount')
        ? Number(localStorage.getItem('discount'))
        : 0,
    }

    store.commit('SET_USERDATA', userData)

    if (userData.discount > 0) {
      store.commit('applyCustomerDiscountOnCart')
    }

    store.commit('setCheckingAuth', true)
    // pre prihlaseneho uzivatela treba nacitat jeho adresu, tym sa aj overi ci token je platny
    axios
      .get(`${serverUrl}/api/v1/addresses`, {
        headers: getAuthHeader(),
      })
      .then((response) => {
        store.commit('setAddressbook', response.data)
        store.commit('setCheckingAuth', false)
        if (next) {
          next()
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 400) {
            store.dispatch('SIGN_OUT')
          }
        }
      })
  } else {
    // Just set authentication to false when no token is present
    store.commit('setAuthenticated', false)
  }
}
